
export function parseDate(dateStr) {
  // 07-12-2018
  const date = dateStr.split('-').map(d => parseInt(d, 10));
  const [day, month, year] = date;
  return new Date(year, month - 1, day);
}
